import * as React from 'react';

import {SetupGuideContext, Step} from 'common/onboarding/immersive-onboarding/types';
import {Content, Header} from 'common/onboarding/immersive-onboarding/components';
import {IMMERSIVE_ASSETS} from 'common/onboarding/immersive-onboarding/assets';
import rocketImg from 'common/onboarding/immersive-onboarding/assets/rocket.svg';

import {WelcomeV1} from './welcome-v1';
import {WelcomeWithPlannedEvents} from './v2/welcome-with-plan';
import {WelcomeV2Default} from './v2/welcome-v2-default';

export const WelcomePhase2 = () => {
  const {setupGuideInfo, completed} = React.useContext(SetupGuideContext);
  const {stepsCompleted} = setupGuideInfo;
  const hasPlannedEvents = stepsCompleted.has(Step.Events);

  return (
    <>
      <Header
        title={`Start Here`}
        step={`step 1`}
        imgSrc={rocketImg}
        duration={3}
        completed={completed[Step.Welcome]}
      />
      <Content>{hasPlannedEvents ? <WelcomeWithPlannedEvents /> : <WelcomeV2Default />}</Content>
    </>
  );
};

export const Welcome = () => {
  const {completed} = React.useContext(SetupGuideContext);

  return (
    <>
      <Header
        title={`Start Here`}
        step={`step 1`}
        imgSrc={IMMERSIVE_ASSETS.toggles}
        duration={3}
        completed={completed[Step.Welcome]}
      />
      <Content>
        <WelcomeV1 />
      </Content>
    </>
  );
};
